export default __webpack_public_path__ + "dd659f0ee2cacec6f40404aad4504ef8.jpg";